<template>
    <div class="tablelist">
        <a-table
            size="middle"
            :key="this.loading.key"
            :columns="columns"
            :rowKey="record => record.id ? record.id : Math.random()"
            :dataSource="list"
            :pagination="false"
            :rowSelection="this.rowSelection"
            :loading="this.loading.effects[selectType] || this.loading.effects[deleteType]"
        >
            <template slot="operation" slot-scope="text,record">
                <router-link
                    class="mr10"
                    :to="{
                    path:'edit',
                    query: {
                        id: record.id,
                        //这里注意this的作用域指向问题
                        referer: JSON.stringify(that.$route.query),
                    }
                }"
                >编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                    <a :disabled="that.loading.effects[deleteType]" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>

            <template slot="operationforjibie" slot-scope="text,record">
                <a @click="e => singlesetting(record)" class="mr10">设置</a>
                <a @click="e => singleupdate(record)">修改</a>
            </template>

            <!-- 修改日志级别 -->
            <template slot="rizhiupdate" slot-scope="text,record">
                <a-select
                    style="width:120px"
                    :defaultValue="text"
                    @change="value => that.updatelevel(value, record)"
                >
                    <a-select-option key="INFO">INFO</a-select-option>
                    <a-select-option key="ERROR">ERROR</a-select-option>
                    <a-select-option key="DEBUG">DEBUG</a-select-option>
                </a-select>
            </template>

            <!-- 表格的页脚 -->
            <template slot="footer" v-if="this.action=='jibie'">
                <a-button @click="batsetting" type="primary" class="mr18">批量设置</a-button>
                <a-button @click="batupdate" type="primary" class="mr18">批量修改</a-button>
                <a-button @click="batsettingbylevel" type="primary">按级别批量设置</a-button>

                <a-modal
                    :visible="showSettingModal"
                    :destroyOnClose="true"
                    @cancel="handleCancel"
                    @ok="handleOkSetting"
                    title="批量设置"
                >
                    <a-form layout="inline" :form="formsetting" class="formitem">
                        <a-form-item label="服务级别" v-if="grouplevel">
                            <a-select
                                placeholder="请选择级别"
                                style="width:200px;"
                                v-decorator="[
                                    'servicelevel',
                                    {
                                        rules:[{required:true, message: '请选择服务级别'}]
                                    }
                                ]"
                            >
                                <a-select-option key="0">级别0</a-select-option>
                                <a-select-option key="1">级别1</a-select-option>
                                <a-select-option key="2">级别2</a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item label="上下线状态">
                            <a-radio-group
                                v-decorator="[
                                    'serviceflag',
                                    {
                                        initialValue: singleRecord.serviceflag || undefined,
                                        rules:[{required: true, message: '状态必选'}]
                                    }
                                ]"
                            >
                                <a-radio value="1">上线</a-radio>
                                <a-radio value="0">下线</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-form>
                </a-modal>

                <a-modal
                    :visible="showUpdateModal"
                    :destroyOnClose="true"
                    @cancel="handleCancel"
                    @ok="handleOkUpdate"
                    title="批量修改"
                >
                    <a-form layout="inline" :form="formupdate" class="formitem">
                        <a-form-item label="服务级别">
                            <a-select
                                placeholder="请选择级别"
                                v-decorator="[
                                    'servicelevel',
                                    {
                                        initialValue: singleRecord.servicelevel || undefined,
                                    }
                                ]"
                                style="width:200px;"
                            >
                                <a-select-option key="0">级别0</a-select-option>
                                <a-select-option key="1">级别1</a-select-option>
                                <a-select-option key="2">级别2</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-form>
                </a-modal>
            </template>
        </a-table>
        <v-pageinfo v-if="pagination.total > 0 && action != 'rizhi'" :pagination="pagination"></v-pageinfo>
    </div>
</template>

<script>
import { mapState } from "vuex";

const storeNamespace = "servicekey";

export default {
    data() {
        return {
            that: this,
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/del`,
            columns: [],
            action: "",
            selectedRows: [],
            selectedRowKeys: [],

            grouplevel: false,

            singleRecord: {},

            formsetting: this.$form.createForm(this),
            formupdate: this.$form.createForm(this),

            showSettingModal: false, //批量设置的modal
            showUpdateModal: false //批量修改的modal
        };
    },
    methods: {
        //设置单个服务级别
        singlesetting(record) {
            console.log(record);
            this.grouplevel = false;
            this.singleRecord = record;
            this.batsetting(false);
        },
        //修改单个服务级别
        singleupdate(record) {
            console.log(record);
            this.grouplevel = false;
            this.singleRecord = record;
            this.batupdate(false);
        },
        //初始化相关数据
        initSelectRecords() {
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.singleRecord = {};
            this.grouplevel = false;
        },
        //显示modal
        showModal(whichModal) {
            this[whichModal] = true;
        },
        //关闭modal
        handleCancel() {
            this.showSettingModal = false;
            this.showUpdateModal = false;
            this.grouplevel = false;
        },
        //保存批量修改
        handleOkUpdate() {
            this.formupdate.validateFields((err, values) => {
                if (err) return;
                if (this.singleRecord["id"]) {
                    //单个设置项
                    values["ids"] = this.singleRecord["id"];
                } else {
                    //批量设置
                    values["ids"] = this.selectedRowKeys.join(",");
                }

                this.handleCancel();
                console.log(
                    values,
                    "handleOkSettinghandleOkSettinghandleOkSetting"
                );
                this.$store
                    .dispatch({
                        type: `${storeNamespace}/batupdate`,
                        params: values
                    })
                    .then(() => {
                        this.initSelectRecords();
                    });
            });
        },
        //保存批量设置
        handleOkSetting() {
            this.formsetting.validateFields((err, values) => {
                if (err) return;
                if (this.grouplevel === false) {
                    if (this.singleRecord["id"]) {
                        //单个设置项
                        values["ids"] = this.singleRecord["id"];
                    } else {
                        //批量设置
                        values["ids"] = this.selectedRowKeys.join(",");
                    }
                } else {
                    delete values.ids;
                }
                this.handleCancel();
                console.log(
                    values,
                    "handleOkSettinghandleOkSettinghandleOkSetting"
                );
                this.$store
                    .dispatch({
                        type: `${storeNamespace}/batsetting`,
                        params: values
                    })
                    .then(() => {
                        this.initSelectRecords();
                    });
            });
        },
        //更新日志级别
        updatelevel(value, record) {
            console.log(value, record);
            record.rootlevel = value;
            this.$store.dispatch({
                type: `${storeNamespace}/rizhiupdate`,
                params: record
            });
        },
        //删除
        onDelete(record) {
            this.$store.dispatch({
                type: this.deleteType,
                params: record
            });
        },
        //检测是否允许点击批量的按钮
        isAllowBat() {
            if (this.selectedRows.length <= 0) {
                this.message.info("请先选择需要修改的数据");
                return false;
            }
            return true;
        },
        //批量设置
        batsetting(checkSelected = true) {
            if (checkSelected && !this.isAllowBat()) return false;
            this.showModal("showSettingModal");
        },
        //按级别批量设置
        batsettingbylevel() {
            this.grouplevel = true;
            this.showModal("showSettingModal");
        },
        //批量修改
        batupdate(checkSelected = true) {
            if (checkSelected && !this.isAllowBat()) return false;
            this.showModal("showUpdateModal");
        }
    },
    computed: {
        ...mapState(storeNamespace, {
            list: state => state.list,
            pagination: state => {
                return state.pagination;
            }
        }),
        rowSelection() {
            let _this = this;
            if (this.action !== "jibie") return null;
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    _this.selectedRows = selectedRows;
                    _this.selectedRowKeys = selectedRowKeys;
                }
                /* onSelect: (record, selected, selectedRows) => {
                    console.log(record, selected, selectedRows);
                }, */
                /* onSelectAll: (selected, selectedRows, changeRows) => {
                    console.log(selected, selectedRows, changeRows);
                } */
            };
        }
    },
    beforeMount() {
        const { path } = this.$route;
        this.action = path.split("/").pop();
    },
    mounted() {
        if (this.action == "list") {
            this.columns = [
                {
                    title: "序号",
                    width: 80,
                    align: "center",
                    customRender: (text, record, index) => ++index
                },
                {
                    title: "服务KEY",
                    dataIndex: "servicekey"
                },
                {
                    title: "服务配置",
                    dataIndex: "serviceconfig"
                },
                {
                    title: "接口类型",
                    dataIndex: "interfacetype",
                    width: 80
                },
                {
                    title: "entry",
                    dataIndex: "entry",
                    customRender: text => (text == "1" ? "是" : "否")
                },
                {
                    title: "服务授权验证码",
                    dataIndex: "authcode"
                },
                {
                    title: "创建时间",
                    dataIndex: "createtime"
                },
                {
                    title: "操作",
                    width: 146,
                    scopedSlots: { customRender: "operation" }
                }
            ];
        } else if (this.action == "jibie") {
            this.columns = [
                {
                    title: "序号",
                    width: 80,
                    align: "center",
                    customRender: (text, record, index) => ++index
                },
                {
                    title: "服务KEY",
                    dataIndex: "servicekey"
                },
                {
                    title: "服务级别",
                    dataIndex: "servicelevel"
                },
                {
                    title: "上下线状态",
                    dataIndex: "serviceflag",
                    customRender: text => (text == "1" ? "线上" : "下线")
                },
                {
                    title: "接口类型",
                    dataIndex: "interfacetype"
                },
                {
                    title: "创建时间",
                    dataIndex: "createtime"
                },
                {
                    title: "操作",
                    width: 146,
                    scopedSlots: { customRender: "operationforjibie" }
                }
            ];
        } else if (this.action == "rizhi") {
            this.columns = [
                {
                    title: "序号",
                    width: 80,
                    align: "center",
                    customRender: (text, record, index) => ++index
                },
                {
                    title: "系统名称",
                    dataIndex: "systemname"
                },
                {
                    title: "root日志级别",
                    dataIndex: "rootlevel",
                    scopedSlots: { customRender: "rizhiupdate" }
                }
            ];
        }

        switch (this.action) {
            case "list":
                this.selectType = `${storeNamespace}/select`;
                break;
            case "jibie":
                this.selectType = `${storeNamespace}/jibie`;
                break;
            case "rizhi":
                this.selectType = `${storeNamespace}/rizhi`;
                break;
            default:
                break;
        }

        this.$store.dispatch({
            type: this.selectType
        });
    }
};
</script>
<style lang="less" scoped>
</style>
